import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgPlus} from "~/assets/svg/plus.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmPlusIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgPlus id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
